<div class="pl-0 col-12">
  <p>
    Sichere Dir eine attraktive Prämie für Dich und einen Neukunden, indem Du uns weiterempfiehlst. <br />
    Gib den unten angegebenen Link zur Depoteröffnung an den von Dir geworbenen Kunden weiter.
  </p>
  <p class="flex-grow mb-0">Dein persönlicher Empfehlungslink lautet:</p>
  <div class="text-color-primary mb-1 d-flex align-items-end">
    <web-design-system-copy-to-clipboard [label]="kwkFacade.promoLink$ | async" hint="Der Link wurde in Deine Zwischenablage kopiert." />
  </div>

  <p class="mt-3">
    Lies hier die genauen
    <a
      class="link-underline link-primary"
      href="https://www.finanzen.net/zero/kunden-werben-kunden"
      target="_blank"
      rel="noopener noreferrer"
      >Teilnahmebedingungen</a
    >.
  </p>
</div>
